import { Component, inject } from '@angular/core';

import { LocalizationPipe } from '@abp/ng.core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_DIALOG } from '@progress/kendo-angular-dialog';

import { SessionExpiryService } from '../../services';

@Component({
  selector: 'nexweb-session-expiry-dialog',
  templateUrl: './session-expiry-dialog.component.html',
  imports: [KENDO_DIALOG, LocalizationPipe, KENDO_BUTTON],
})
export class SessionExpiryDialogComponent {
  private sessionExpiry = inject(SessionExpiryService);

  get showDialog(): boolean {
    return this.sessionExpiry.showDialog;
  }

  get timerCountDown(): number {
    return this.sessionExpiry.timerCountDown;
  }

  public continueWorking() {
    this.sessionExpiry.continueWorking();
  }

  public logOut() {
    this.sessionExpiry.logOut();
  }
}
